/* eslint-disable dot-notation */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { Button, Grid, Card, CardContent, CardActions, Typography, Box } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import JSON_CONST from '../../../components/CONSTVALUE.json';

// Register fonts for pdfMake
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;



export default function PDFRenderExecutiveWiseMISReportTwo() {
    const ref = useRef();
    const navigate = useNavigate();
    const params = useParams();
    const [resData, setResData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [paramsData] = useState(params.data ? JSON.parse(decodeURI(params.data)) : {});
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.post(`${JSON_CONST.DB_URL}option/typeWiseReport`, paramsData)
                const sortedData = response.data.sort((a, b) => a.bankName.name.localeCompare(b.bankName.name));
                setResData(sortedData);
                console.log(sortedData)
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [paramsData]);

    
   
   const exportToExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const formattedFromDate = moment(paramsData?.from).format("DD-MM-YYYY");
        const formattedToDate = moment(paramsData?.to).format("DD-MM-YYYY");
        const titleRow = ["Export ILO LEGAL ADVISORY | Advocates, Legal Advisers & Consultants"];
        const titleRows = ["Type Wise Report"];
        const dateRow = [`FROM: ${formattedFromDate} | TO: ${formattedToDate}`];
        const emptyRow = [""]; // Empty row for spacing

        
        const headers = ['S.NO', 'Rep Date', 'Bank', 'Branch', 'Customer Name', 'Aps No', 'Ref No', 'Seller Name', 'Phone No','ODV','Prepared By','Type','Address','Roof Right','Receipt Date','Sent On','Status','Remarks'];
        
        const formattedData = resData.map((row, index) => [
            index + 1,
            moment(row.reportDate).format('DD-MM-YYYY'),
            row.bankName?.name || '',
            row?.branchName?.name || '',
            row.customerBorrower || '',
            row.apsNo || '',
            row.refNo || '',
            row.uid || '',
            row.phoneNo || '',
            row.searchExpName?.name || '',
            row.preparedByName?.name || '',
            row.type?.name || '',
            [
            row.flatHousePlotNo,
            row.floor,
            row.streetSectorLocal,
            row.city
            ].filter(Boolean).join(' '),
            row.roofRight || '',
            row.reciptDate || '',
            row.reportSentOn || '',
            row.statusValue || '',
            row.remarks || ''
        ]);
        const dataXLSX = [
        titleRow,
        titleRows,
        dateRow,
        headers,
        emptyRow,
        ...formattedData
    ];
        
        const ws = XLSX.utils.aoa_to_sheet(dataXLSX);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        FileSaver.saveAs(data, `TypeWiseReport.xlsx`);
    };
    const exportToPdf = () => {
    const formattedFromDate = moment(paramsData?.from).format("DD-MM-YYYY");
    const formattedToDate = moment(paramsData?.to).format("DD-MM-YYYY");

    // Define column widths (adjust as needed)
    const columnWidths = ['5%', '10%', '10%', '10%', '10%', '7%', '7%', '10%', '10%','7%', '10%', '10%', '10%', '7%', '7%', '7%', '7%', '10%'];

    const docDefinition = {
        pageOrientation: 'landscape',
        pageSize: 'A4',
        content: [
            { text: 'COMSYS IT LEGAL ADVISORY', style: 'header' },
            { text: 'Advocates, Legal AdvisOrs & Consultants', style: 'subheader' },
            { text: 'Type Wise Report', style: 'subheader' },
            { text: `FROM: ${formattedFromDate} | TO: ${formattedToDate}`, style: "subheader" },
            {
                style: 'tableExample',
                table: {
                    headerRows: 1, // Repeat header on every page
                    widths: columnWidths, // Set column widths explicitly
                    body: [
                        // Table Header
                        ['S.NO', 'Rep Date', 'Bank', 'Branch', 'Customer Name', 'Aps No', 'Ref No', 'Seller Name', 'Phone No','ODV', 'Prepared By', 'Type', 'Address', 'Roof Right', 'Receipt Date', 'Sent On', 'Status', 'Remarks'],
                        
                        // Table Data
                        ...resData.map((row, index) => [
                            index + 1,
                            moment(row.reportDate).format('DD-MM-YYYY'),
                            row.bankName?.name || '',
                            row?.branchName?.name || '',
                            row.customerBorrower || '',
                            row.apsNo || '',
                            row.refNo || '',
                            row.uid || '',
                            row.phoneNo || '',
                            row.searchExpName?.name || '',
                            row.preparedByName?.name || '',
                            row.type?.name || '',
                            [
                            row.flatHousePlotNo,
                            row.floor,
                            row.streetSectorLocal,
                            row.city
                            ].filter(Boolean).join(' '),
                            row.roofRight || '',
                            row.reciptDate ? moment(row.reciptDate).format('DD-MM-YYYY') : '',
                            row.reportSentOn ? moment(row.reportSentOn).format('DD-MM-YYYY') : '',
                            row.statusValue || '',
                            row.remarks || ''
                        ]),
                    ],
                },
                layout: 'lightHorizontalLines', // Adds table styling
                dontBreakRows: true, // Allows rows to split properly
            },
        ],
        styles: {
            header: { fontSize: 18, bold: true, alignment: 'center' },
            subheader: { fontSize: 12, bold: true, alignment: 'center' },
            tableExample: { margin: [0, 5, 0, 15] },
        },
        defaultStyle: { fontSize: 9 }, // Smaller font size to fit more content
    };

    pdfMake.createPdf(docDefinition).download('type_wise_Report.pdf');
};


    const redirectPage = (url) => {
        navigate(`/app/${url}`, { replace: true });
    };
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                      
                    <Button style={{backgroundColor: 'black', color: 'white'}} variant="contained" color="inherit" onClick={() => navigate('/app/reportOpinion/typeWiseMISReport/0')}>
                        ← Back
                    </Button>
                </Grid>

                <Grid item xs={6}>
                    <Card style={{ backgroundColor: '#B14019' }} sx={{ minWidth: 345 }}>
                        <CardContent>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: '140px', color: 'white' }} />
                            <Typography gutterBottom variant="h5" component="div" style={{ color: 'white' }}>
                                PDF EXPORT 
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button style={{ backgroundColor: '#F9F9F9' }} onClick={exportToPdf} size="small">PDF</Button>
                            &nbsp;&nbsp;&nbsp;<sub style={{ color: '#F9F9F9' }}>Click to open/download</sub>
                        </CardActions>
                    </Card>
                </Grid>
               <Grid item xs={6}>
                    <Card style={{ backgroundColor: '#1C9F44' }} sx={{ minWidth: 345 }}>
                        <CardContent>
                            <FileDownloadOutlinedIcon style={{ fontSize: '140px', color: 'white' }} />
                            <Typography gutterBottom variant="h5" component="div" style={{ color: 'white' }}>
                                XLSX EXPORT
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button style={{ backgroundColor: '#F9F9F9' }} onClick={exportToExcel} size="small">XLSX</Button>
                            &nbsp;&nbsp;&nbsp;<sub style={{ color: '#F9F9F9' }}>Click to open/download</sub>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
